import { toast } from 'react-toastify';

export function CatchErrors(err) {
  if (Array.isArray(err)) {
    err.map(e => toast.error(Object.values(e)[0]));
  }
  else toast.error(String(err));
}